import React from 'react'
import PropTypes from 'prop-types'
import RowButton from 'components/atoms/row-button'
import { ExclusiveSellerGenderBadge } from 'domains/exclusive-seller/atoms/gender-badge'

const propTypes = {
  buttonText       : PropTypes.string,
  buttonColour     : PropTypes.string,
  isButtonDisabled : PropTypes.func,
  onButtonClick    : PropTypes.func
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

/**
 * Columns definition for Seller Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */

const exclusiveSellerTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {
  const GenderCell = (row) => <ExclusiveSellerGenderBadge gender= { row.cell.value } />

  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        disabled={ disabled }
        text={ buttonText }
      />
    )
  }

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header   : 'Code',
        accessor : 'code'
      },
      {
        Header   : 'Name',
        accessor : 'name'
      },
      {
        Header   : 'Gender',
        accessor : 'gender',
        Filter   : false,
        Cell     : GenderCell
      },
      {
        Header   : 'Username',
        accessor : 'username'
      },
      {
        Header   : 'Mobile',
        Filter   : false,
        accessor : 'mobile'
      },
      {
        Header   : 'Email',
        accessor : 'email'
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

exclusiveSellerTableColumns.propTypes = propTypes

export default exclusiveSellerTableColumns
